import styles from './empty-state.module.css'

export const getCoreClasses = (horizontal: boolean, className?: string) => {
  return `${!horizontal ? styles.core : styles['core-horizontal']} ${className || ''}`
}

export const getImageClasses = (horizontal: boolean) => {
  return `${!horizontal ? styles.image : styles['image-horizontal']}`
}

export const getTitleClasses = (horizontal: boolean) => {
  return `${styles.title} ${horizontal && styles['align-left']}`
}
export const getSubTitleClasses = (horizontal: boolean) => {
  return `${styles['sub-title']} ${horizontal && styles['align-left']}`
}
